import React from 'react';
import { Form, Input, Checkbox } from 'antd';
import { useParams } from 'react-router-dom';
import UploadDragger from '../../../formComponents/UploadDragger';
import TextField from '../../../formComponents/TextField';
import SelectField from '../../../formComponents/SelectField';
import OwnersSelectField from '../../../formComponents/OwnersSelectField';
import {
  firstAndSecondLinesFields,
  fourthLineSelectFields,
  textAreaField,
  thirdLineFields,
} from '../constants/fieldsData';
import { validationRules, addUpperIndex } from '../../constants';
import useRoomsStates from '../../../../queries/useRoomsStates';
import useRoomsTypes from '../../../../queries/useRoomsTypes';
import { getSelectPopupContainer } from '../utils/getSelectPopupContainer';
import useCompanyServices from '../../../../queries/useCompanyServices';
import styles from '../../modalStyles.module.scss';
import ServicesSelectField from '../../../formComponents/ServicesSelectField';

const { TextArea } = Input;

const RoomForm = ({
  form,
  fileList,
  setFileList,
  imagesList,
  setImagesList,
  editingRoom,
  numberError,
}) => {
  const { getFieldDecorator } = form;

  const params = useParams();

  const { data: statuses } = useRoomsStates();
  const { data: types } = useRoomsTypes();
  const { data: companyServices } = useCompanyServices(params.facilityId);

  return (
    <Form layout="vertical" id="room-form">
      <UploadDragger
        label="Изображения"
        fileList={imagesList}
        onlyPicture
        setState={setImagesList}
        iconProps={{ type: 'picture' }}
        description="перетащите , или нажмите, чтобы загрузить
            изображение"
      />

      {firstAndSecondLinesFields.map((field) => (
        <TextField
          key={field.name}
          label={field.label}
          name={field.name}
          options={{
            initialValue: field.getInitialValue(editingRoom),
            rules: field.rules,
          }}
          getFieldDecorator={getFieldDecorator}
          inputProps={field.inputProps}
        />
      ))}

      <div className={styles.flex}>
        {thirdLineFields.map((field) => (
          <TextField
            key={field.name}
            className={styles.flexFull}
            label={field.label}
            name={field.name}
            inputProps={field.inputProps}
            getFieldDecorator={getFieldDecorator}
            options={{
              initialValue: field.getInitialValue(editingRoom),
              rules: field.rules,
            }}
            validateStatus={
              typeof field.validateStatus === 'function'
                ? field.validateStatus(numberError)
                : undefined
            }
            help={
              typeof field.help === 'function'
                ? field.help(numberError)
                : undefined
            }
          />
        ))}
      </div>

      <div className={styles.flex}>
        {fourthLineSelectFields.map((field) => (
          <SelectField
            key={field.name}
            className={styles.flexFull}
            label={field.label}
            name={field.name}
            getFieldDecorator={getFieldDecorator}
            selectProps={field.selectProps}
            items={field.name === 'status' ? statuses : types}
            options={{
              initialValue: field.getInitialValue(editingRoom),
              rules: field.rules,
            }}
          />
        ))}

        <TextField
          className={styles.flexFull}
          label="Стоимость аренды"
          name="price"
          options={{
            initialValue: editingRoom?.price && String(editingRoom.price),
            rules: [
              validationRules.required('Укажите стоимость аренды'),
              validationRules.number,
            ],
          }}
          getFieldDecorator={getFieldDecorator}
          inputProps={{ suffix: addUpperIndex('руб./ м', '2') }}
        />
      </div>

      <Form.Item>
        {getFieldDecorator('isMop', {
          valuePropName: 'checked',
          initialValue: Boolean(editingRoom?.isMop),
        })(<Checkbox>Есть МОП</Checkbox>)}
      </Form.Item>

      <OwnersSelectField
        form={form}
        initialOwners={editingRoom?.landLords}
        selectClassName={styles.flexFull}
        addFieldBtnClassName={styles.addFieldBtn}
        getPopupContainer={getSelectPopupContainer}
      />

      <ServicesSelectField
        form={form}
        getPopupContainer={getSelectPopupContainer}
        editingRoom={editingRoom}
      />

      {textAreaField.map((field) => (
        <Form.Item label={field.label} key={field.name}>
          {getFieldDecorator(field.name, {
            initialValue: field.getInitialValue(editingRoom),
          })(<TextArea {...field.areaProps} />)}
        </Form.Item>
      ))}

      <UploadDragger
        label="Документы"
        fileList={fileList}
        setState={setFileList}
        iconProps={{ type: 'file-add', theme: 'outlined' }}
        description="перетащите файлы сюда,
            или нажмите, чтобы выбрать"
      />
    </Form>
  );
};

export default RoomForm;
